<script>
import Card from "@/components/molecules/card";
import LazyImage from "@/components/atoms/lazy-image";
import Button from "@/components/atoms/button";

export default {
  name: "PaymentMethod",
  components: {
    Card,
    LazyImage,
    Button
  },
  props: {
    carte: {
      type: Object,
      required: false,
      default: () => {}
    }
  },
  emits: ["renameCard", "deleteCard"],

  data() {
    return {};
  },
  methods: {}
};
</script>

<template>
  <Card
    :class="carte.attributes.is_expired && 'c-payment-method-cards-registered--disabled'"
    class="c-payment-method-cards-registered u-p-md u-pt-sm@md u-px-sm@md u-pb-xs25@md"
    radius="md"
    border-color="grey-4"
  >
    <div class="c-payment-method-cards-registered__wrapper">
      <div class="c-payment-method-cards-registered__content">
        <LazyImage
          v-if="carte.attributes.reseau_emeteur_logo"
          :src="carte.attributes.reseau_emeteur_logo"
          alt="logo reseau emeteur"
          class="c-payment-method-cards-registered__img"
          width="45"
          height="28"
        />
        <div class="c-payment-method-cards-registered__infos">
          <div class="c-payment-method-cards-registered__left">
            <p class="u-font-700 u-mb-xs u-mb-none@md">
              {{ carte.attributes.libelle }}
            </p>
            <p class="u-font-16">
              {{ carte.attributes.reseau_emeteur }} {{ carteBancaireMasque(carte.attributes.num_carte) }}
            </p>
          </div>
          <div class="c-payment-method-cards-registered__right">
            <span
              v-if="carte.attributes.is_expired"
              class="u-font-700 u-color-alert"
            > Expirée </span>
            <span v-else-if="carte.attributes.expiration_annee && carte.attributes.expiration_mois">Date d’expiration {{ carte.attributes.expiration_mois }}/20{{ carte.attributes.expiration_annee }}</span>
          </div>
        </div>
      </div>
      <div class="c-payment-method-cards-registered__actions">
        <Button
          v-if="!carte.attributes.is_expired"
          link
          @click="$emit('renameCard')"
        >
          Renommer
        </Button>
        <Button
          link
          @click="$emit('deleteCard')"
        >
          Supprimer
        </Button>
      </div>
    </div>
  </Card>
</template>

<style lang="scss" scoped>
@import "@/assets/styles/components/payment-method-cards-registered.scss";
</style>
